import { PropertyDesignationGQL } from "./External";

function createEnumObject<T extends string>(o: { [P in T]: P }) {
  return o;
}

export const PropertyDesignation = createEnumObject<PropertyDesignationGQL>({
  Residential: "Residential",
  Commercial: "Commercial",
  Other: "Other",
});
